export default "__VITE_ASSET__CFFVQpSX__"